export default Object.freeze({
  INCLUSION: 'INCLUSION',
  EXCLUSION: 'EXCLUSION',
});
